import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { OccEndpointsService } from '@spartacus/core';
import { Observable } from 'rxjs';

@Injectable()
export class UigEtilizeRedirectAdapter {

  constructor (protected http: HttpClient, protected occEndpoints: OccEndpointsService) {}

  getRedirectUrl(): Observable<string> {
    return this.http.get<string>(this.occEndpoints.buildUrl('etilizeRedirect'));
  }
}
